// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZJ8MXVeg7P0uefr9ZMQw{flex-direction:column;flex-grow:1;gap:6px;height:100%;display:flex}.mNJPGzo9AEfeIyVvbZdG{flex-grow:1;height:100%;display:flex;position:relative}.qChofwCFATIkAkdx4GX7{text-align:center;margin-top:240px;margin-left:auto;margin-right:auto;position:absolute;left:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ZJ8MXVeg7P0uefr9ZMQw`,
	"table": `mNJPGzo9AEfeIyVvbZdG`,
	"emptyState": `qChofwCFATIkAkdx4GX7`
};
export default ___CSS_LOADER_EXPORT___;
